import App from '@app/index';
import '@patternfly/react-core/dist/styles/base.css';
import * as React from 'react';
import ReactDOM from 'react-dom/client';
import '@app/i18n/i18n';
import LazyI18nProvider from '@app/i18n/LazyI18nProvider';

import { KeycloakAuth } from '@project/auth/keycloakInstance';

// Use a different approach eg https://www.deque.com/axe/devtools/extension/
// or other linting/test tools.  
// if (process.env.NODE_ENV !== 'production') {
//   const config = {
//     rules: [
//       {
//         id: 'color-contrast',
//         enabled: false,
//       },
//     ],
//   };
//  
//   const axe = require('react-axe');
//   axe(React, ReactDOM, 1000, config);
// }

const root = ReactDOM.createRoot(document.getElementById('root') as Element);

root.render(
  <KeycloakAuth>
    <React.StrictMode>
      <LazyI18nProvider lng="en">
        <App />
      </LazyI18nProvider>
    </React.StrictMode>
  </KeycloakAuth>,
);
